import { render, staticRenderFns } from "./ArrowTest.vue?vue&type=template&id=271d6d9b&"
import script from "./ArrowTest.vue?vue&type=script&lang=js&"
export * from "./ArrowTest.vue?vue&type=script&lang=js&"
import style0 from "./ArrowTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports